<template>
  <div style="background: #dfe1e4 ;">
    <!-- 上传 -->
    <div v-if="!isUpload2">
      <uploader
              v-if="!isUpload2"
              browse_button="browse_button"
              :url="server_config"
              chunk_size="2MB"
              :max_retries="3"
              :filters="getFilters"
              :FilesAdded="filesAdded"
              :FileUploaded="FileUploaded"
              :FileFiltered="FileFiltered"
              :BeforeUpload="beforeUpload"
              :multi_selection="false"
              :Error="error"
              :UploadComplete="uploadComplete"
              @inputUploader="inputUploader"
      >
      </uploader>
    </div>

    <el-button id="browse_button" v-if="!isUpload2" size="mini">
      <em class="el-icon-plus"></em>
      <span>上传视频</span>
    </el-button>

    <div  v-if="isUpload2">
      <div v-if="tableData.length>0" style="width: 170px;">
        <span v-if="tableData[0].status === -1">正在验证文件</span>
        <span v-if="tableData[0].status === 1 && tableData[0].percent === 0">验证完成，准备上传</span>
        <span v-if="tableData[0].status === 4" style="color: brown">上传失败</span>
        <span v-if="tableData[0].status === 5" >已上传</span>
        <el-progress v-if="tableData[0].status === 2 || tableData[0].status === 1 && tableData[0].percent > 0" :text-inside="true" :stroke-width="20" :percentage="tableData[0].percent"></el-progress>
        <br/>
        <!--删除上传-->
        <el-button  @click="deleteFileVideo(tableData[0].id)" size="mini"><em class="el-icon-delete"></em></el-button>
        <!--开始上传-->
        <el-button :disabled="uploading" @click="uploadStart()" size="mini"><em class="el-icon-upload2"></em></el-button>
      </div>
    </div>
  </div>

</template>

<script>
  import modifyCSImg from '../../creationSharing/modifyCSImg'
  import FileMd5 from '../../creationSharing/js/models/file-md5'
  import Uploader from '../../creationSharing/js/Uploader'
  import axios from 'axios'

  // import modifyCoverImg from '../learning/common/modifyImg/modifyCSImg'
  export default {
    components: { modifyCSImg ,'uploader': Uploader, FileMd5},
    name: "uploadFile",
    props:{
      urlData:{
        type: String,
      }
    },
    data() {
      return {
        isEdit: true,
        coverUrl: 'https://tasit.blob.core.chinacloudapi.cn/resource/8a7480997a05f56b017a139027980037cover.jpg',
        imgsrc:'',
        modifyCoverImgVisible: false,
        isUpload1 : false ,
        isUpload2 : false ,
        isUpload2Show: false,
        dynamicTags: [],
        setHeaders:{
          code:'fHQXfWPl0Jfkr4biXhlsbq9Msvg9VJ0smyHIzsGVEWY'
        },

        browse_button: 'browse_button',
        server_config:  window.SITE_CONFIG['apiBaseURL'] + "/grow/breakpointfile/appUpload",
        // server_config: "/api/grow/breakpointfile/appUpload",
        up: {},
        files:[],
        tableData: [],
        uploading: false,
        getFilters:{
          // mime_types : [ //只允许上传pdf和zip文件
          //   { title : "mp4 files", extensions : "mp4" },
          //   { title : "mov files", extensions : "mov" },
          // ],
          // max_file_size : '1048576kb', //最大只能上传1GB的文件
          // prevent_duplicates : true //不允许选取重复文件
        },
        duration: 0,
      };
    },
    watch: {
      files: {
        handler() {
          console.log('----777-----',this.files)
          this.tableData = [];
          this.files.forEach((e) => {
            this.tableData.push({
              name: e.name,
              size: e.size,
              status: e.status,
              id: e.id,
              percent: e.percent
            });
          });
        },
        deep: true
      }
    },
    methods: {
      inputUploader(up) {
        console.log('----222-----')
        console.log(up)
        this.up = up;
        this.files = up.files;
      },

      filesAdded(up, files) {
        console.log('----666-----',up,files)
        console.log(this.tableData)
        if (this.tableData.length > 1) {
          this.$message.warning("只能上传一个视频")
          return
        }
        var file = files[0].getNative();//获取被plupload处理后的真实
        if (!this.beforeAvatarUpload(file)) {
          this.isUpload2 = false
          this.deleteFileVideo(this.tableData[0].id)
          return;
        }
        var url = URL.createObjectURL(file);
        var audioElement = new Audio(url);
        var duration = 0;
        var thist = this
        audioElement.addEventListener("loadedmetadata", function(_event) {
          duration = Math.floor(audioElement.duration);
          console.log('多媒体时长add', duration);
          thist.duration = duration
          console.log('多媒体时长add', this.duration);

        });
        console.log('多媒体时长', duration);
        this.duration = duration
        console.log('多媒体时长', this.duration);

        files.forEach((f) => {
          f.status = -1;
          FileMd5(f.getNative(), (e, md5) => {
            f["md5"] = md5;
            f.status = 1;
          });
        });
      },

      FileFiltered(uploader,file){
        console.log('----444-----')
        console.log(uploader)
        console.log(file)
        const isFormat = file.type.indexOf('mp4') !== -1 || file.type.indexOf('quicktime') !== -1 ;
        const is1024MB = file.size / 1024 / 1024 < 1024;
        if (isFormat&&is1024MB) {
          this.isUpload2 = true
        }
      },


      // 文件上传删除回调
      deleteFileVideo(id) {
        let file = this.up.getFile(id);
        this.up.removeFile(file);
        console.log('deleteFile')
        // 上传列表删除前 删除后当前列表无数据. 上传图片按钮恢复. 列表隐藏
        if(this.tableData.length === 1){
          // 上传图片按钮恢复.
          this.uploading = false
          // 列表隐藏
          this.isUpload2 = false
        }
        // this.fileList2清空
        this.fileList2 = []
        this.$emit('fileId')
      },
      beforeUpload(up, file) {
        console.log('----333-----')
        up.setOption("multipart_params", {"size":file.size,"md5":file.md5});
        console.log('beforeUpload .... ')
        console.log(file.size)
      },
      /***************************开始上传*******************/
      uploadStart() {
        var file = this.files[0].getNative();//获取被plupload处理后的真实
        if(this.tableData.length > 1){
          this.$message.warning("只能上传一个文件")
          return false;
        }else if (this.files[0].status !== 1){
          this.$message.warning("文件未验证完成,不能上传")
          return false;
        }else if (!this.beforeAvatarUpload(file)) {
          return false;
        } else {
          // 禁止点击选择文件按钮
          this.uploading = true;
          // this.up.start();
          // TODO 自定义上传
          this.upStart()
          this.$emit('fileId', this.tableData[0].id)
        }
      },

      /*************切片************/
      upStart(){
        console.log('upStart')
        console.log(this.tableData)
        console.log(this.files)
        console.log(this.up)
        console.log('.getNative()')
        console.log(this.files[0].getNative())
        var file = this.files[0].getNative()
        var start = 0
        var end = 2097152
        // 第一个切片
        var partFile = file.slice(start,end);
        console.log(partFile)

        var name = this.files[0].name
        var md5 = this.files[0].md5
        var size = this.files[0].size
        var chunk = 0
        var chunks = Math.ceil(size/2097152)
        // * @param name  文件名
        // * @param md5   文件md5值
        // * @param size  文件大小(Bytes)
        // * @param chunk    文件分片 当前片 0开始
        // * @param chunks     文件分片 一共多少片 1开始
        // * @param file      文件


        // 1. 先请求一个接口获取所有切片保存情况
        // 2. 循环发送请求
        // 3. 发现失败重试3次
        var uploadState = {
          fileMd5:md5,
          remarks:chunks,
        }

        this.$request.post('/grow/breakpointfile/appGetUploadState', uploadState).then((res, total, code, data) => {
          // 结束
          if(data.code === 1){
            console.log('appGetUploadState')
            console.log(data.data)
            var checksAll = data.data.split('')
            var chunk = 0
            for (let i = 0; i < checksAll.length; i++) {
              console.log('checksAll' + i + '   ' + checksAll[i])
              if(checksAll[i] === '0'){
                chunk = i
                break
              }
            }
            console.log(chunk)
            // TODO 开始分片上传
            start = chunk * 2097152
            if(chunk === (chunks-1)){
              end = size
            }else {
              end = (chunk+1) * 2097152
            }

            var part_file = file.slice(start,end);
            this.files[0].status = 2
            this.files[0].percent = Math.ceil(chunk/chunks * 100 )

            // clearTimeout(this.timer);  //清除延迟执行

            console.log('=============================')
            console.log('file', part_file)
            console.log('name', name)
            console.log('md5', md5)
            console.log('size', size)
            console.log('chunk', chunk)
            console.log('chunks', chunks)
            console.log('files', this.files[0].percent)
            console.log('=============================')

            let formData = new FormData();
            formData.append('file', partFile )
            formData.append('name', name )
            formData.append('md5', md5 )
            formData.append('size', size )
            formData.append('chunk', chunk )
            formData.append('chunks', chunks )

            this.upFile(chunk, chunks);

          }else{
            this.$message.error(data.msg)
          }
        }).catch((err) => {
          console.log(err)
        })
      },

      /****************************上传切片文件***************/
      upFile(i, chunks){
        var _this = this

        var file = this.files[0].getNative()
        var name = this.files[0].name
        var md5 = this.files[0].md5
        var size = this.files[0].size

        var start = i * 2097152
        var end = 0
        if(i === (chunks-1)){
          end = size
        }else {
          end = (i+1) * 2097152
        }
        var part_file = file.slice(start,end);
        this.files[0].status = 2
        this.files[0].percent = Math.ceil(i/chunks * 100 )
        // clearTimeout(this.timer);  //清除延迟执行
        console.log('=============================')
        console.log('file', part_file)
        console.log('name', name)
        console.log('md5', md5)
        console.log('size', size)
        console.log('chunk', i)
        console.log('chunks', chunks)
        console.log('files', this.files[0].percent)
        console.log('=============================')
        let formData = new FormData();
        formData.append('file', part_file )
        formData.append('name', name )
        formData.append('md5', md5 )
        formData.append('size', size )
        formData.append('chunk', i )
        formData.append('chunks', chunks )
        axios.post(this.server_config, formData,{
          headers: {
            'Content-Type': 'multipart/form-data;'
          }
        }).then((res, total, code, data) => {
          console.log('res')
          console.log(res)
          if(res.data.code === 1){
            var urlData = res.data.data
            console.log('urlData')
            if(urlData !== null && urlData.indexOf('http') !== -1){
              this.files[0].status = 5
              this.files[0].percent = 100
              this.FileUploaded(null,this.files[0],urlData);
            }else {
              i ++
              if(i < chunks){
                _this.upFile(i, chunks)
              }else {
                this.files[0].percent = 100
                this.files[0].status = 5
                // TODO 上传结束后调用
                //TODO 上传后调用 成功回调接口
                this.FileUploaded(null,this.files[0],urlData);
                console.log('上传结束')
              }
            }
          }else {
            this.$message.error(data.msg)
          }
        }).catch((err) => {
          console.log(err)
        })
      },
      // ****************************************************************上传成功后回调*********************************
      FileUploaded(uploader,file,urlData){
        console.log('----555-----')
        let fileUrl = urlData
        let fileMD5 = file.md5
        let fileName = file.name
        this.$emit('fileUrlData', urlData)
        console.log('-------------------')
        // this.$emit("videoAddress", fileUrl)
        console.log(fileUrl)
        console.log(fileMD5)
        console.log(fileName)
        // 截取文件名称后缀  小写
        let fileNameType = fileName.substr(fileName.lastIndexOf('.')).toLowerCase()
        console.log(fileNameType)
      },

      /*****暂停上传******/
      uploadStop() {
        this.uploading = false;
        this.up.stop();
      },
      error() {
        this.uploading = false;
      },
      uploadComplete() {
        console.log('----111-----')
        this.uploading = false;
      },

      // url不对
      codeError(){
        // this.dialogVisibleError = false
        window.location.href="about:blank";
        window.close();
      },

      modifyCoverImg() {
        if(this.isEdit){
          this.modifyCoverImgVisible = true
          this.$nextTick(() => {
            this.$refs.modifyCoverImg.init(this.dataForm.userId, 'cover')
          })
        }
      },
      refreshCoverImg(data) {
        console.log('refreshImg')
        console.log(data)
        this.coverUrl = data.url
      },

      beforeAvatarUpload(file){
        // 校验视频格式(也可直接用 accept 属性限制如：accept="image/png,image/jpg,image/jpeg,image/gif")
        const isFormat = file.type.indexOf('mp4') !== -1 || file.type.indexOf('quicktime') !== -1 ;
        // 校验视频大小
        const is1024MB = file.size / 1024 / 1024 < 1024;
        console.log('文件大小：',file.size / 1024 / 1024,'M')
        console.log('文件格式：',file.type)
        if (!isFormat) {
          this.$message.error('上传视频支持 mp4、mov格式!');
          return false
        } else if (!is1024MB) {
          this.$message.error('上传视频大小不能超过 1G!');
          return false
        } else {
          return true
        }
        // return false ;
      },

      handleClose(tag) {
        if(this.isEdit){
          this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
        }
      }
    }
  }
</script>

<style scoped>

</style>
